import React, { FC } from 'react';

interface IProps {
  title: string;
  values: string[];
}

const SummaryTableHeadRow: FC<IProps> = props => {
  const { title, values } = props;

  return (
    <tr className="thead">
      <td className="text">
        <div className="value">{title}</div>
      </td>

      {values.map((h, index) => (
        <td key={`${title}-td-${h}-${index}`}>
          <div className="value">{h}</div>
        </td>
      ))}
    </tr>
  );
};

export default SummaryTableHeadRow;
